module.exports = __webpack_public_path__ + "static/media/spaceclean.9c52fcf4.png";